export const ActionTypes = {
  LOGIN: 'LOGIN',
  LOG_OUT: 'LOG_OUT',
  GET_USER_INFO: 'GET_USER_INFO',
  SET_USER_LANGUAGE: 'SET_USER_LANGUAGE',
};
